# GraphQL fragment to enable/disable Google task sync

#import "../fragments/task-sync.graphql"

mutation setGoogleTaskSyncIsEnabled($isEnabled: Boolean!) {
    setGoogleTaskSyncIsEnabled(input: {taskSync: {isEnabled: $isEnabled}}) {
        authUrl
        taskSync {
            ...TaskSync
        }
    }
}
